import { DeleteOutlined, PlusOutlined, SearchOutlined } from "@ant-design/icons";
import { AutoComplete, Button, DatePicker, Drawer, Form, FormInstance, FormProps, Input, Select, TreeSelect } from "antd";
import { useForm } from "antd/es/form/Form";
import dayjs from "dayjs";
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { getInfoCustomer } from "../../../../api/customer/customerApi";
import * as IssuedCardsApi from '../../../../api/rank/issuedCardApi';
import * as RankApi from '../../../../api/rank/rankApi';
import * as SelectOptionApi from '../../../../api/selectOptions/selectOptionsApi';
import { buildTreeData, convertGroupValueToTreeV2 } from "../../../../api/unit/unitApi";
import useDebounce from "../../../../hook/useDebounce";
import useLoading from "../../../../hook/useLoading";
import useToast from "../../../../hook/useToast";
import { selectorCategoryCarIds } from "../../../../store/slices/categoryCarSlice";
import { fommatSelectOption, fommatSelectOptionV2, formatDateV2, handleStringToDayJsV4 } from "../../../../until";
import './style.scss';


type FieldType = {
  personContactId: number
  listCarePolicies: number[]
  username: string;
  phone: string;
  rank: number;
  releaseDate: any;
  expirationDate: any;
};

interface CustomerFilterSearch {
  searchProfession?: string
  searchPersonContact?: string
  searchPolicies?: string
}


export interface InforSelectedCodeCustomer {
  value?: string
  label?: string
  id?: number
  phone?: string
}

interface DrawerProps {
  isOpen: boolean
  dataRank: IssuedCardsApi.IListRankEdit[]

  confirmModalAdd: (isSucces: boolean, errorMesses?: string) => void
  closeDrawer: () => void
}


const DrawerAddCard: React.FC<DrawerProps> = ({
  isOpen,
  dataRank,
  closeDrawer,
  confirmModalAdd
}) => {
  const [form] = useForm();
  const inputRef = useRef<FormInstance<FieldType>>(null);
  const pushToast = useToast();
  const pushLoading = useLoading();
  const permittedCategoryCarIds = useSelector(selectorCategoryCarIds)

  const rankId = Form.useWatch('rank', form)
  const selectedPolicies = Form.useWatch('listCarePolicies', form) ?? []

  const [arrayCustomer, setArrayCustomer] = useState<SelectOptionApi.ISelectOption[]>([])
  const [idCustomer, setIdCustomer] = useState<number>(0)
  const [selectedRank, setSelectedRank] = useState<number | undefined>(undefined);
  const [policyRows, setPolicyRows] = useState<number[]>([Date.now()]);
  const [benefitOptions, setBenefitOptions] = useState<any[]>([]);
  const popupRef = useRef<HTMLDivElement>(null);
  const [paginationCodeCustomer, setPaginationCodeCustomer] = useState({ current: 1, pageSize: 30, total: 0 });
  const [sLCodeCustomer, setSLCodeCustomer] = useState<SelectOptionApi.ICodeCustomer[]>([])
  const [searchFilters, setSearchFilters] = useState<CustomerFilterSearch>();
  const [inforSelectedCodeCustomer, setInforSelectedCodeCustomer] = useState<InforSelectedCodeCustomer>()

  const [dataBenefitRank, setDataBenefitRank] = useState<RankApi.IInfoRank>()

  const submitForm = () => {
    if (inputRef.current) {
      inputRef.current.submit();
    }
  };

  const handleChange = (value: number) => {
    setSelectedRank(value);
  };


  const gSListCodeCustomer = useDebounce(async (current: number = 1) => {
    pushLoading(true)
    const result = await SelectOptionApi.getListCodeCustomer(
      permittedCategoryCarIds,
      undefined, searchFilters?.searchPersonContact, undefined, undefined, 50, current, 1
    );
    if (result?.status) {
      // Append nếu current > 1
      setSLCodeCustomer(prev =>
        current === 1
          ? result.data                // load lần đầu
          : [...prev, ...result.data]  // append
      );

      setPaginationCodeCustomer(prev => ({
        ...prev,
        current,
        total: result.total || 0
      }));
    }
    pushLoading(false)
  }, 500)

  const gInfoCustomer = async () => {
    pushLoading(true)
    form.resetFields()
    const result = await getInfoCustomer(Number(inforSelectedCodeCustomer?.id))
    if (result?.status) {
      const { userName, gender, phone, CCCD, profession, email, relativeId, rank } = result.data

      rank?.listcarePolicieId &&
        setPolicyRows(
          rank.listcarePolicieId.length > 0
            ? rank.listcarePolicieId.map(() => Date.now() + Math.random())
            : [Date.now()]
        );

      form.setFieldsValue({
        "personContactId": inforSelectedCodeCustomer?.value,
        "username": userName[0].username,
        "gender": gender,
        "phone": inforSelectedCodeCustomer?.phone,
        "CCCD": CCCD,
        "professionId": profession?.id,
        "email": email,
        "relativeId": relativeId,
        "expirationDate": handleStringToDayJsV4(rank?.expirationDate),
        "releaseDate": handleStringToDayJsV4(rank?.releaseDate),
        'listCarePolicies': rank?.listcarePolicieId?.map(item => item.id),

      });


    } else {
      pushToast(result?.message, "error")
    }
    pushLoading(false)
  }


  const onPopupScroll = (e: any) => {
    const target = e.target;

    const isBottom =
      target.scrollTop + target.clientHeight >= target.scrollHeight - 20;

    if (!isBottom) return;

    const { current, total } = paginationCodeCustomer;
    const hasMore = sLCodeCustomer.length < total;

    if (!hasMore) return;

    gSListCodeCustomer(current + 1);
  };

  const handleSelectCodeCustomer = (value: InforSelectedCodeCustomer) => {
    setInforSelectedCodeCustomer(value)
  }


  const formatDate = (date: Date) => {

    const formatted = dayjs(date).format("YYYY/MM/DD");

    return formatted;
  }


  const onFinish: FormProps<FieldType>["onFinish"] = async (values: FieldType) => {
    // const groupIdPolicies = dataBenefitRank?.carePolicies


    const groupIdPolicies = [
      ...new Set([
        ...(values.listCarePolicies || []),
        ...(dataBenefitRank?.carePolicies?.map(item => item.id) || []),
      ]),
    ];
    const expirationDateTmp = values.expirationDate ? formatDateV2(values.expirationDate) : undefined
    const releaseDateTmp = values.releaseDate ? formatDateV2(values.releaseDate) : undefined

    const result = await IssuedCardsApi.addCardIssuance([inforSelectedCodeCustomer?.id || 0], groupIdPolicies, formatDate(values.releaseDate), expirationDateTmp, values.rank);
    if (result?.status) {
      confirmModalAdd?.(true)
    } else {
      confirmModalAdd?.(false, result.message)
    }
  };


  const getListCarePolicyBenefitsTree = useDebounce(async () => {
    const result = await SelectOptionApi.getListCarePolicyBenefitsTree(searchFilters?.searchPolicies, rankId)
    if (result?.status) {
      setBenefitOptions(convertGroupValueToTreeV2(result.data))
    }
  }, 500)


  const getInfoRank = async () => {
    if (!rankId) return
    const result = await RankApi.getInfoRank(rankId);
    if (result.status) {
      // setDataBenefitRank(result.data)

      setDataBenefitRank(result.data);

      const currentPolicies =
        form.getFieldValue("listCarePolicies") ?? [];

      const rankPolicyIds =
        result.data.carePolicies?.map(x => x.id) ?? [];

      const remainPolicies =
        currentPolicies.filter(
          (id: number) => !rankPolicyIds.includes(id)
        );

      form.setFieldValue(
        "listCarePolicies",
        remainPolicies
      );

      setPolicyRows(
        remainPolicies.length
          ? remainPolicies.map(() => Date.now() + Math.random())
          : []
      );


    } else {
      pushToast(result.message, "error", 2000)
    }
  }

  const handleSelectCustomer = (value: number) => {
    setIdCustomer(value)
    const selectedOption = arrayCustomer.find(option => option.value === value);
    if (selectedOption) {
      let nameAndPhone = selectedOption.label.split(" (");
      form.setFieldValue('username', nameAndPhone[0])
      form.setFieldValue('phone', nameAndPhone[1].slice(0, -1))
    }
  }

  const fommatSelectOption2 = (arr: SelectOptionApi.IListCustomerBenefit[]) => {
    return arr?.map(item => ({
      value: item.id,
      label: item.name + ' (' + item.phone + ')'
    }));
  }

  const addPolicyRow = () => {
    setPolicyRows(prev => [...prev, Date.now()]);
  };

  const removePolicyRow = (index: number) => {
    setPolicyRows(prev => prev.filter((_, i) => i !== index));
    const policies: (number | undefined)[] = form.getFieldValue('listCarePolicies') ?? [];
    form.setFieldValue('listCarePolicies', policies.filter((_, i) => i !== index));
  };

  // useEffect(() => {
  //   const handleOutsideClick = (e: MouseEvent) => {
  //     if (popupRef.current && !popupRef.current.contains(e.target as Node)) {
  //       if (onClose) onClose();
  //     }
  //   };
  //   document.addEventListener("mousedown", handleOutsideClick);
  //   return () => document.removeEventListener("mousedown", handleOutsideClick);
  // }, [onClose]);

  useEffect(() => {
    if (isOpen)
      gSListCodeCustomer()
  }, [searchFilters?.searchPersonContact, isOpen])


  useEffect(() => {
    if (inforSelectedCodeCustomer?.id) {
      gInfoCustomer()
    }
  }, [inforSelectedCodeCustomer])

  useEffect(() => {
    setDataBenefitRank(undefined)
    getInfoRank()

    // form.setFieldsValue({
    //   listCarePolicies: [],
    // });

    // setPolicyRows([]);
  }, [rankId])


  useEffect(() => {
    if (isOpen)
      getListCarePolicyBenefitsTree()
  }, [rankId, searchFilters?.searchPolicies, isOpen])

  useEffect(() => {
    if (!isOpen) {
      form.resetFields()
      setSearchFilters(undefined)
      setPolicyRows([]);
      setDataBenefitRank(undefined);
    } else {
      gSListCodeCustomer()
    }
  }, [isOpen])

  return (
    <Drawer
      title={undefined}
      placement="right"
      rootClassName="custom-drawer"
      closable={false}
      onClose={closeDrawer}
      open={isOpen}
      footer={undefined}
    >
      <div
        ref={popupRef}
        className="filter-setting add-card-issuance"
        id="addcardissuance"
      >
        <div className="title-add-filter">
          <span>Phát hành thẻ</span>
        </div>
        <div className="content-filter-setting-add t-scrollbar">
          {/* <Select
            showSearch
            className="custome-select"
            placeholder="Tìm và chọn khách hàng"
            options={arrayCustomer}
            getPopupContainer={() => document.getElementById('addcardissuance') || document.body}
            onChange={(value) => handleSelectCustomer(value)}
            suffixIcon={<SearchOutlined />}
          /> */}

          <div className="text-sm  font-medium py-2 text-344054">Thông tin thẻ</div>

          <Form
            ref={inputRef}
            form={form}
            className="form-block"
            initialValues={{ remember: true }}
            onFinish={onFinish}
            autoComplete="off"
            layout="vertical"
          >
            {/* <Form.Item<FieldType>
            label={<span className="">Mã định danh khách hàng<span className="pl-1" style={{ color: 'red' }}>*</span></span>}
            name="iduser"
            rules={[{ required: true, message: 'Vui lòng nhập mã định danh khách hàng!' }]}
          >
            <Input placeholder="Mã định danh khách hàng" />
          </Form.Item> */}

            <div className="d-flex flex-column gap-2">
              <p className="text-sm  font-regular text-344054 d-flex gap-2 align-center">
                Mã định danh khách hàng :
              </p>
              <Form.Item<FieldType>
                layout='vertical'
                name="personContactId"
              // rules={[{ required: true, message: 'Vui lòng chọn Mã định danh khách hàng' }]}
              >
                <AutoComplete
                  // ref={scrollRef}
                  // className="custom-input-css custom-page-css border"
                  onPopupScroll={onPopupScroll}
                  placeholder="Mã định danh khách hàng"
                  getPopupContainer={() => document.getElementById('addcardissuance') || document.body}
                  options={sLCodeCustomer.map((item) => ({
                    value: item.code,         // Giá trị hiển thị trong ô tìm kiếm
                    label: `${item.code} - ${item.username}`, // Gợi ý hiển thị dropdown
                    id: item.id,              // Giá trị thực tế bạn muốn lấy khi chọn
                    phone: item.phone,          // Thêm thông tin khác nếu cần
                  }))}
                  // filterOption={(inputValue, option) =>
                  //   !!option?.value?.toLowerCase().includes(inputValue.toLowerCase())
                  // }
                  showSearch
                  filterOption={false}
                  onSearch={(value) => setSearchFilters({ ...searchFilters, searchPersonContact: value })}
                  onBlur={() => {
                    // Giữ lại search value khi blur, hoặc có thể reset nếu muốn
                    setSearchFilters({ ...searchFilters, searchPersonContact: '' }); // Nếu muốn reset khi blur

                  }}
                  onSelect={(value, option) => {
                    handleSelectCodeCustomer(option)
                  }}
                >
                  <Input className="custom-input-css custom-page-css border px-2" />
                </AutoComplete>
              </Form.Item>
            </div>

            <Form.Item<FieldType>
              label={<span className="">Tên khách hàng/ Tổ chức<span className="pl-1" style={{ color: 'red' }}>*</span></span>}
              name="username"

              rules={[{ required: true, message: 'Vui lòng nhập tên khách hàng!' }]}
            >
              <Input
                disabled
                placeholder="Tên khách hàng/ Tổ chức"
                className="custom-input-css custom-page-css border  pl-2"
              />
            </Form.Item>

            <Form.Item<FieldType>
              label={<span className="">Điện thoại<span className="pl-1" style={{ color: 'red' }}>*</span></span>}
              name="phone"

              rules={[{ required: true, message: 'Vui lòng nhập số điện thoại!' }]}
            >
              <Input
                disabled
                placeholder="Điện thoại"
                className="custom-input-css custom-page-css border pl-2 "
              />
            </Form.Item>

            <div className="date-row">
              <Form.Item<FieldType>
                label={<span className="">Ngày phát hành<span className="pl-1" style={{ color: 'red' }}>*</span></span>}
                name="releaseDate"
                rules={[{ required: true, message: 'Vui lòng chọn ngày phát hành!' }]}
              >
                <DatePicker
                  placeholder="Ngày phát hành"
                  format={'DD/MM/YYYY'}
                  className="custom-input-date w-full"
                  getPopupContainer={() => document.getElementById('addcardissuance') || document.body}
                />
              </Form.Item>
              <Form.Item<FieldType>
                label="Ngày hết hạn"
                name="expirationDate" rules={[
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      const releaseDate = getFieldValue("releaseDate");

                      // Không nhập ngày hết hạn thì bỏ qua
                      if (!value || !releaseDate) {
                        return Promise.resolve();
                      }

                      if (value.isAfter(releaseDate, "day")) {
                        return Promise.resolve();
                      }

                      return Promise.reject(
                        new Error("Ngày hết hạn phải lớn hơn ngày phát hành!")
                      );
                    },
                  }),
                ]}
              >
                <DatePicker
                  placeholder="Ngày hết hạn"
                  format={'DD/MM/YYYY'}
                  className="custom-input-date w-full"
                  getPopupContainer={() => document.getElementById('addcardissuance') || document.body}
                />
              </Form.Item>
            </div>

            <Form.Item<FieldType>
              label="Hạng thẻ"
              name="rank"
            >
              <Select
                className='custom-page-css border rounded overflow-hidden'
                placeholder="Hạng thẻ"
                onChange={handleChange}
                allowClear
                onClear={() => setDataBenefitRank(undefined)}
                value={selectedRank}
                options={fommatSelectOptionV2(dataRank)}
              />
            </Form.Item>
            <div className="custom-page-css flex flex-col gap-1">
              {dataBenefitRank?.carePolicies?.map(item =>

                <span>{item.title}</span>
              )}
            </div>

            {policyRows.map((rowId, index) => (
              <div key={rowId} className="policy-row">
                <DeleteOutlined
                  className="policy-delete-icon"
                  onClick={() => removePolicyRow(index)}
                />
                <Form.Item<FieldType>
                  name={['listCarePolicies', index]}
                  className="custom-page-css w-full overflow-hidden"
                  rules={[
                    {
                      validator(_, value) {
                        if (dataBenefitRank && dataBenefitRank?.carePolicies?.length > 0) {
                          return Promise.resolve();
                        }

                        if (value !== undefined && value !== null) {
                          return Promise.resolve();
                        }

                        return Promise.reject(
                          new Error("Vui lòng chọn chính sách CSKH!")
                        );
                      },
                    },
                  ]}
                  style={{ flex: 1, marginBottom: 0 }}
                >
                  {/* <Select
                  className='custom-page-css border rounded overflow-hidden'
                  placeholder="Chọn chính sách CSKH"
                
                  options={benefitOptions}
                /> */}
                  <TreeSelect
                    className='custom-page-css w-full border rounded overflow-hidden text-truncate'
                    showSearch
                    placeholder="Chọn chính sách CSKH"
                    allowClear
                    // value={dataFilterTmp.group}
                    treeDefaultExpandAll={false}
                    treeData={buildTreeData(
                      benefitOptions,
                      selectedPolicies,
                      form.getFieldValue(['listCarePolicies', index])
                    )}
                    getPopupContainer={() => document.getElementById('addcardissuance') || document.body}
                    filterTreeNode={false}
                    onSearch={(value) => setSearchFilters({ ...searchFilters, searchPolicies: value })}
                    onBlur={() => setSearchFilters({ ...searchFilters, searchPolicies: '' })}
                  // onChange={(e) => setDataFilterTmp({ ...dataFilterTmp, group: e !== undefined ? e : undefined })}
                  // onClear={() => setDataFilterTmp({ ...dataFilterTmp, group: undefined })}
                  />
                </Form.Item>
              </div>
            ))}

            <Button
              type="dashed"
              className="btn-add-policy"
              onClick={addPolicyRow}
              icon={<PlusOutlined />}
            >
              Thêm chính sách CSKH
            </Button>
          </Form>
        </div>

        <div className="footer-filter-block">
          <div className="btn-block">
            <Button className="btn btn-primary" onClick={submitForm}>
              <div className="text">
                Phát hành
              </div>
            </Button>
          </div>
        </div>
      </div>
    </Drawer>

  )
}
export default DrawerAddCard
